<script>
import { VTimelineItem } from 'vuetify/lib'

export default {
  name: 'ETimelineItem',
  props: {
    label: String,
    schedule: Number,
    description: String,
    time: [String, Date, Number],
  },
  extends: VTimelineItem,
  methods: {
    genBody() {
      const schedule = this.schedule
        ? this.$createElement('div', { staticClass: 'e-timeline-item__schedule' }, this.schedule)
        : null
      const label = this.$createElement('div', { staticClass: 'e-timeline-item__label' }, this.label)
      const time = this.$createElement('div', { staticClass: 'e-timeline-item__time' }, this.time)
      const main = this.$createElement('div', { staticClass: 'e-timeline-item__content-main' }, [schedule, label, time])
      const sub = this.description
        ? this.$createElement('div', { staticClass: 'e-timeline-item__content-sub' }, this.description)
        : null
      const content = this.$createElement('div', { staticClass: 'e-timeline-item__content' }, [main, sub])
      return this.$createElement(
        'div',
        {
          staticClass: 'v-timeline-item__body',
        },
        this.$slots.default ? this.$slots.default : [content]
      )
    },
    genDivider() {
      return this.$createElement('div', {
        staticClass: 'v-timeline-item__divider',
      })
    },
  },
  render(h) {
    const children = [this.genBody(), this.genDivider()]
    if (this.$slots.opposite) children.push(this.genOpposite())
    return h(
      'div',
      {
        staticClass: 'v-timeline-item',
        class: {
          'e-timeline-item': true,
          'v-timeline-item--fill-dot': this.fillDot,
          'v-timeline-item--before': this.timeline.reverse ? this.right : this.left,
          'v-timeline-item--after': this.timeline.reverse ? this.left : this.right,
          ...this.themeClasses,
        },
      },
      children
    )
  },
}
</script>
